import React from 'react';
import Grid from '@mui/material/Grid2';
import { Save, Send } from '@mui/icons-material';
import { RegisterButton, RequestButton } from '../style/button';

const TaskAssignmentButtons = ({ onSave, onNotify }) => {
    return (
        <Grid 
            container 
            spacing={3}
            sx={{ 
                justifyContent: 'flex-end',
                alignItems: 'center',
                '& .MuiButton-root': {
                    whiteSpace: 'nowrap',
                    width: { xs: '100%', md: 'fit-content' },  // コンテンツに合わせて幅を設定
                    minWidth: { md: 'fit-content' },  // mdサイズ以上でコンテンツに合わせる
                    padding: { xs: '12px 24px', md: '12px 32px' }  // パディングを調整
                }
            }}
        >
            <Grid 
                size={{ xs: 12, md: 'auto' }}  // autoに変更してコンテンツ幅に合わせる
                sx={{ 
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
            >
                <RegisterButton
                    onClick={onSave}
                    startIcon={<Save />}
                >
                    業務割当を反映する
                </RegisterButton>
            </Grid>
            <Grid 
                size={{ xs: 12, md: 'auto' }}  // autoに変更してコンテンツ幅に合わせる
                sx={{ 
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
            >
                <RequestButton
                    onClick={onNotify}
                    startIcon={<Send />}
                >
                    業務割当結果を通知する
                </RequestButton>
            </Grid>
        </Grid>
    );
};

export default TaskAssignmentButtons;